import classNames from "classnames";
import * as React from "react";
import { Link, useLocation } from "react-router-dom";
// import { isMobile } from "react-device-detect";
import logo from "../img/Logo.png";
import { TeaserStateContext } from "../util/app-state";
import "./Header.scss";
interface IAppMenuProps {}

const AppMenu: React.FunctionComponent<IAppMenuProps> = (props) => {
  const [open, setOpen] = React.useState(false);
  const location = useLocation();
  const teaserState = React.useContext(TeaserStateContext);
  const showAll = teaserState.launch === "hard";

  return (
    <div className="AppMenu">
      <div
        className={classNames("menu-toggle", { open })}
        role="button"
        onClick={() => setOpen(!open)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul className={classNames("menu", { open })}>
        {showAll && (
          <>
            <li>
              <a
                className=""
                href="https://youtu.be/bZM_ZzxihTg"
                target="_blank"
                rel="noreferrer"
              >
                Press Conference
              </a>
            </li>
            <li>
              <Link to="/media/booth">Booth</Link>
            </li>
            <li className={location.pathname === "/facts" ? "active" : ""}>
              <Link to="/facts">Fact Sheet</Link>
            </li>
            <li className={location.pathname === "/experts" ? "active" : ""}>
              <Link to="/experts">Meet The Experts</Link>
            </li>
            <li className={location.pathname === "/media" ? "active" : ""}>
              <Link to="/media">Resources</Link>
            </li>
          </>
        )}
        <li>
          <a
            className="OutlineButton header active"
            href="https://ces2021.deere.com"
            target="_blank"
            rel="noreferrer"
          >
            REVISIT CES<sup>®</sup> 2021 <span>→</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default AppMenu;

interface IHeaderProps {}

export const Header: React.FunctionComponent<IHeaderProps> = (props) => {
  return (
    <header>
      <Link to="/">
        <img src={logo} alt="" />
      </Link>
      <AppMenu />
    </header>
  );
};
